import { hotelsEn } from './en'

export const hotelsEnGb = { ...hotelsEn }
